function roundNumber(num) {
    return Math.round(num)
}

function integerPart(num) {
    return Math.trunc(num)
}

function formatterNumber(value) {
    if (value && value.length === 0) return null
    return value.replace(/[^0-9.]/g, '');
}

function formatterPrice(value, maxValue = null) {
    if (maxValue && parserPrice(value) >= maxValue) value = maxValue + ''
    return (value + '').replace(/[^0-9.]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function parserPrice(value, maxValue = null) {
    if (maxValue && parserPrice(value) >= maxValue) value = maxValue + ''
    return (value + '').replace(/[^0-9.]/g, '').replace(/\$\s?|(,*)/g, '');
}

// Excel/file downloads use responseType: 'blob', so on error the JSON error
// body arrives as a Blob — read and parse it to get the localized message.
async function blobErrorMessage(response, fallback) {
    const data = response?.data;
    if (data instanceof Blob) {
        try {
            return JSON.parse(await data.text())?.message || fallback;
        } catch (e) {
            return fallback;
        }
    }
    return data?.message || fallback;
}

// Content-Disposition'dan fayl nomi; bo'lmasa fallback. Header CORS'da ochiq.
function filenameFromResponse(headers, fallback) {
    const disposition = headers?.["content-disposition"] || "";
    const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
    if (encoded) {
        try {
            return decodeURIComponent(encoded[1]);
        } catch (e) {
            // buzilgan encoding — quyidagi oddiy filename'ga tushamiz
        }
    }
    const plain = /filename="?([^";]+)"?/i.exec(disposition);
    if (plain) return plain[1].trim();
    return fallback || "fayl";
}

function saveBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

const dataUpdate = (val, object = [], data) => {
    let reserve = [];
    object.forEach((item) => {
        reserve.push(item);
        if (item.value === val) {
            item["children"] = data.map((child) => {
                return {
                    label: child.title,
                    value: child.id
                };
            });
        } else {
            dataUpdate(val, item.children, data);
        }
    });
    return reserve;
};


export {
    roundNumber,
    integerPart,
    formatterPrice,
    parserPrice,
    formatterNumber,
    dataUpdate,
    blobErrorMessage,
    filenameFromResponse,
    saveBlob
}
